import CommonService from './common.service';
import { generateQueryParams } from 'utils';
import { _Object } from 'utils/interfaces';

class PurchaseService extends CommonService {
  async getPurchases(params: _Object | string) {
    return await this.get(`purchases?${generateQueryParams(params)}`)
  }
  async getPurchaseDetails(id: string) {
    return await this.get(`purchases/${id}`)
  }
  async createPurchase(parmas: { [key: string]: boolean | string }) {
    return await this.post('purchases', parmas)
  }
  async updatePurchase(id: string, params: { [key: string]: boolean | string }) {
    return await this.put(`purchases/${id}`, params)
  }
  async deletePurchase(id: string) {
    return await this.delete(`purchases/${id}`)
  }

  async addPurchasePayment(parmas: { [key: string]: boolean | string }) {
    return await this.post('purchases/payments', parmas)
  }
}
export const purchaseService = new PurchaseService();